import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'

import { addTemplate, updateTemplate } from '../../redux/slices/templateSlice'
import { errorToast, successToast } from '../../util/Toast/toast'
import { SpinnerContext } from '../../context/spinnerContext'
import { emailSchema } from '../../util/validationSchema'

const NotificationAddEditModal = ({ toggle, setIsRefresh, editData, ID, role }) => {
  const dispatch = useDispatch()
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({ resolver: yupResolver(emailSchema), defaultValues: {} })
  const { changeLoader } = useContext(SpinnerContext)
  // eslint-disable-next-line no-unused-vars
  const [editEmailData, setEditEmailData] = useState(editData)

  const defultValues = {
    template_type: '',
    subject: '',
    body: ''
  }

  useEffect(() => {
    if (ID && editEmailData) {
      reset(updatedValues)
    } else {
      reset(defultValues)
    }
  }, [editEmailData, reset, ID])

  const updatedValues = ID
    ? {
        template_type: [{ type: editEmailData?.template_type }],
        subject: editEmailData?.subject || '',
        body: editEmailData?.body || ''
      }
    : defultValues

  const onSubmit = (data) => {
    setIsRefresh(false)
    if (ID) {
      const payload = {
        ...data,

        template_id: ID,
        template_type: 'NOTIFICATION',
        role: role
      }
      dispatch(updateTemplate(payload)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          toggle()
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
          reset(defultValues)
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    } else {
      const payload = {
        ...data,
        template_type: 'NOTIFICATION',
        role: role
      }
      dispatch(addTemplate(payload)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          toggle()
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
          reset(defultValues)
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card-body add-vendor pb-4">
              <div className="form-group-item border-0 pb-0 mb-0">
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>
                        Notification Subject <span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="subject"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control bg-transparent"
                              autoComplete="off"
                              value={value}
                              type="text"
                              placeholder="Template Subject"
                              onChange={(val) => {
                                onChange(val)
                              }}
                            />
                            <small>{errors?.subject?.message}</small>
                          </>
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>
                        Message <span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="body"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <textarea
                              className="form-control bg-transparent"
                              autoComplete="off"
                              value={value}
                              rows={5}
                              type="text"
                              placeholder="Message"
                              onChange={(val) => {
                                onChange(val)
                              }}
                            />
                            <small>{errors?.body?.message}</small>
                          </>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="multi_btn_div">
                <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary common-field-btn w-100">
                  {editData ? 'Update' : 'Save'} Template
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default NotificationAddEditModal
